import * as angular from 'angular';
import * as _ from "lodash";
import { apsEnums } from "../../shared/dto/aps.enums";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { Enums } from "../../shared/config/constant.module";
import { apsCommands } from "../../shared/dto/aps.commands";
import { apsEvents } from "../../shared/dto/aps.events";
import GobActivity from "../../models/activity/gobActivity";
import { SectionActivity, ShopActivity, MachineActivity } from "../../models/activity/shopActivity";
import { DefectClassification, DefectType, padLegacyId } from "../../models/defectType";
import DateUtilityService from "../../services/utility/dateutility.service";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import DefectServiceName, { DefectService } from "../../services/defects/defect.service";
import DefectTypeServiceName, { DefectTypesAndClassifications, DefectTypeService } from "../../services/defects/defectType.service";
import UIUtilityServiceName, { EnumOption } from "../../services/utility/uiUtility.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import AuthServiceName, { AuthService } from "../../services/auth/auth.service";
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";
import PlantServiceName, { PlantService } from "../../services/plant/plant.service";
import NewGuidServiceName, { NewGuidService } from "../../services/utility/newguid.service";
import template from './addDefect.tpl.html';
import { StateParams } from "../../common";
import EquipmentServiceName, { EquipmentService } from "../../services/equipment/equipment.service";


let requires = [LoaderServiceName, DefectServiceName, DefectTypeServiceName, NotifyServiceName, AuthServiceName,
  AuthDataServiceName, NewGuidServiceName, PlantServiceName, UIUtilityServiceName, EquipmentServiceName];

interface FrequencyType {
  id: apsEnums.FrequencyType;
  name: string;
}

interface AddDefectCtrl {
  shopId: string;
  lastGob: GobActivity;
  defectTypeSelectSize: number;
  displayValidationResults: boolean;
  isMoldRejectInUse: boolean;
  defectFilter: string;
  defectTypes: DefectType[];
  defectTypeId: string;
  frequencyTypes: FrequencyType[];
  frequencyType: FrequencyType;
  frequencyCount: number;
  frequencyTotal: number;
  frequencyPercent: number;
  isCount(): boolean;
  isPercentage(): boolean;
  isPSI(): boolean;
  isThermal(): boolean;
  isPsiOrThermal(): boolean;
  timeFound: Date;
  defectComment: string;
  drops: GobActivity[];
  machineLevelDrop: GobActivity;
  activity: ShopActivity;
  sections: SectionActivity[];
  section: SectionActivity;
  gobs(): GobActivity[];
  gob: GobActivity;
  molds(): apsViewModels.ToolActivity[];
  mold: apsViewModels.ToolActivity;
  classifications: DefectClassification[];
  classification: DefectClassification;
  locationX: number;
  locationY: number;
  equipment: apsViewModels.DefectEquipmentSelection;
  equipmentList: apsViewModels.DefectEquipmentSelection[];
  maxTime: string;
  minTime: string;
  form: angular.IFormController;
  machineLevel: boolean;
  machine: MachineActivity;
  isEquipmentFailure: boolean;
  timeZone: string;
  showMaintCheckbox: boolean;
  discardMold: boolean;
  discardMoldOptions: any;
  discardInvalidMolds: boolean;
  showMoldLoss: boolean;
  isCritical: boolean;
  moldLossEquipment: apsEnums.EquipmentType;
  moldLossEquipments: EnumOption[];
  throwSelectEquipmentError: boolean;
  filteredDefectTypes(): DefectType[];
  sectionChanged(): void;
  gobChanged(): void;
  moldChanged(): void;
  frequencyTypeChanged(): void;
  getDefectTypesAndClassifications(): void;
  drawDefect(x: number, y: number): void;
  addOnClick(event: any): void;
  cancel(): void;
  sectionIsNotValid(): boolean;
  gobIsNotValid(): boolean;
  moldIsNotValid(): boolean;
  timeFoundIsNotValid(): boolean;
  defectTypeIsNotValid(): boolean;
  addDefect(): void;
  equipmentFailureClick(): void;
  changeMachineLevel(): void;
  defectTypeChanged(): void;
  setMoldLossOptions(): void;

  readyForSubmit: boolean;
}

export interface AddDefectData {
  gob: GobActivity;
  date: Date;
  plantId: string
}

export function openAddDefect(
  data: AddDefectData,
  $modal: mm.foundation.modal): angular.IPromise<any> {

  return $modal.open({
    template: template,
    controller: 'AddDefectCtrl as vm',
    resolve: {
      data: () => data
    }
  }).result;
}

export default angular.module('aps.controller.defects', requires)
  .controller('AddDefectCtrl', addDefectCtrl)
  .name;

function addDefectCtrl(
  $modalInstance: mm.foundation.modalInstance,
  $q: angular.IQService,
  loaderService: LoaderService,
  defectService: DefectService,
  defectTypeService: DefectTypeService,
  data: AddDefectData,
  notifyService: NotifyService,
  authService: AuthService,
  authDataService: AuthDataService,
  newGuidService: NewGuidService,
  plantService: PlantService,
  $stateParams: StateParams,
  equipmentService: EquipmentService) {

  var vm = <AddDefectCtrl>this;
  var defectMarkIdentifier = 'defectMarkID';
  var bottleIdentifier = 'defectBottleID';

  vm.defectTypeSelectSize = 6;
  vm.isMoldRejectInUse = false;
  vm.defectFilter = '';
  vm.machineLevel = (data.gob.gobNumber || 0) <= 0;
  vm.readyForSubmit = false;
  vm.isEquipmentFailure = false;
  vm.defectComment = '';
  vm.isCritical = false;

  vm.machine = data.gob.section.machine;
  vm.activity = vm.machine.shop;
  vm.timeZone = vm.activity.timeZoneId;
  vm.sections = vm.activity.sections;
  vm.drops = vm.sections[0].gobs;

  var range = DateUtilityService.getHourRange(data.date, vm.activity.timeZoneId);
  vm.timeFound = range.initialTime.toDate();
  vm.minTime = range.minTime;
  vm.maxTime = range.maxTime;
  vm.showMaintCheckbox = false;
  vm.defectTypeId = null;

  vm.showMaintCheckbox = true;

  vm.frequencyTypes = [
    Enums.FREQUENCY_TYPES.COUNT,
    Enums.FREQUENCY_TYPES.XOVER4,
    Enums.FREQUENCY_TYPES.XOVER10
  ];

    vm.discardMoldOptions = [{ name: true, value: 'YES' }, { name: false, value: 'NO' }, { name: undefined, value: 'N/A' }]; 
    vm.setMoldLossOptions = function () {
    plantService.getPlants().then(plants => {
    this.plants = plants;
    this.selectedPlant = this.plants.filter(p => p.id === data.plantId)[0];

    vm.moldLossEquipments = [];
    if (this.selectedPlant.name === 'Lawrenceburg') {
        vm.moldLossEquipments.push({
            value: undefined,
            text: 'N/A'
        });
      }

    equipmentService.getShop(this.shopId)
      .then((activeEquipment: apsViewModels.EquipmentDetail[]) => {

        if (activeEquipment.some(e => e.type === apsEnums.EquipmentType.Multi)) {
          vm.moldLossEquipments.push({
            value: apsEnums.EquipmentType.Multi,
            text: 'Multi'
          });
        }

        if (activeEquipment.some(e => e.type === apsEnums.EquipmentType.MX4)) {
          vm.moldLossEquipments.push({
            value: apsEnums.EquipmentType.MX4,
            text: 'MX4'
          });
        }

        if (activeEquipment.some(e => e.type === apsEnums.EquipmentType.FlexM)) {
          vm.moldLossEquipments.push({
            value: apsEnums.EquipmentType.FlexM,
            text: 'FlexM'
          });
        }

        if (activeEquipment.some(e => e.type === apsEnums.EquipmentType.WBF) && this.selectedPlant.name !== 'Elmira') {
          vm.moldLossEquipments.push({
            value: apsEnums.EquipmentType.WBF,
            text: 'WBF'
          });
        }

        if (vm.moldLossEquipments.length > 0) {
            vm.moldLossEquipment = vm.moldLossEquipments[0].value;
        }
      });
    });
  };

  plantService.getPlatFeatureSettings($stateParams.plantId)
    .then(function (tmpDat) {
      if (tmpDat && tmpDat.config) {
        var tmp = JSON.parse(tmpDat.config);
        var userRoleLocation = authDataService.getSelectedRoleLocation();
        if (tmp && tmp.moldLoss && tmp.moldLoss.shops) {

          vm.throwSelectEquipmentError = false;
          vm.showMoldLoss = (_.includes(tmp.moldLoss.shops, '*') || _.includes(tmp.moldLoss.shops, vm.shopId))
            && (_.includes(tmp.moldLoss.roles, '*') || _.includes(tmp.moldLoss.roles, userRoleLocation.role.roleId));
          if (vm.showMoldLoss) {
            vm.setMoldLossOptions();
            vm.discardMold = true;
            vm.discardInvalidMolds = undefined;
            vm.throwSelectEquipmentError = true;
          }
        }
      }
    });

  vm.gobs = function () {
    if (vm.section) {
      return vm.section.gobs;
    }
    return [];
  };

  vm.molds = function (): any[] {
    var molds = [];
    _.forEach(vm.sections, (section: SectionActivity) => {
      _.forEach(section.gobs, function (gob: any) {
        molds.push(gob.moldOnDate(vm.timeFound));
      });
    });
    return molds;
  };

  vm.sectionChanged = function () {
    if (vm.section) {
      vm.gob = _.find(vm.section.gobs, { name: vm.lastGob.name });
      vm.lastGob = vm.gob;
      vm.mold = vm.gob.moldOnDate(vm.timeFound);
    }
  };

  vm.gobChanged = function () {
    vm.lastGob = vm.gob;
    vm.mold = vm.gob.moldOnDate(vm.timeFound);
  };

  vm.moldChanged = function () {
    _.forEach(vm.sections, function (section: SectionActivity) {
      _.forEach(section.gobs, function (gob: GobActivity) {
        if (vm.mold === gob.moldOnDate(vm.timeFound)) {
          vm.section = section;
          vm.gob = gob;
          vm.lastGob = gob;
          return false;
        }
        return true;
      });
    });
  };

  vm.frequencyTypeChanged = function () {
    switch (vm.frequencyType) {
      case Enums.FREQUENCY_TYPES.XOVER4:
        vm.frequencyPercent = undefined;
        vm.frequencyTotal = 4;
        break;
      case Enums.FREQUENCY_TYPES.XOVER10:
        vm.frequencyPercent = undefined;
        vm.frequencyTotal = 10;
        break;
      default:
        vm.frequencyPercent = undefined;
        vm.frequencyTotal = undefined;
        break;
    }
  };

  vm.isCount = (): boolean =>
    vm.frequencyType
    && vm.frequencyType.id !== apsEnums.FrequencyType.Percentage
    && vm.frequencyType.id !== apsEnums.FrequencyType.None;

  vm.isPercentage = (): boolean =>
    vm.frequencyType && vm.frequencyType.id === apsEnums.FrequencyType.Percentage;

  vm.isPSI = (): boolean =>
    vm.frequencyType && vm.frequencyType.id === apsEnums.FrequencyType.PSI;

  vm.isThermal = (): boolean =>
    vm.frequencyType && vm.frequencyType.id === apsEnums.FrequencyType.ThermalShock;

  vm.isPsiOrThermal = (): boolean =>
    vm.frequencyType && (vm.frequencyType.id === apsEnums.FrequencyType.PSI
      || vm.frequencyType.id === apsEnums.FrequencyType.ThermalShock);

  vm.shopId = vm.activity.id;
  vm.lastGob = data.gob;
  if (!vm.machineLevel) {
    vm.section = data.gob.section;
    vm.gob = data.gob;
    vm.mold = data.gob.moldOnDate(vm.timeFound);
  }

  function filterDefectTypes(defectType: DefectType) {
    return (!defectType) ||
      (!vm.classification ||
        defectType.classification === vm.classification) &&
      (vm.defectFilter.length === 0 ||
        defectType.name.toLowerCase().indexOf(
          vm.defectFilter.toLowerCase()) > -1 ||
        (defectType.legacyId && _.startsWith(padLegacyId(defectType.legacyId), vm.defectFilter)));
  }

  vm.filteredDefectTypes = (): DefectType[] => {
    var defectTypes = _.filter(vm.defectTypes, filterDefectTypes);
    if (vm.isEquipmentFailure) {
      defectTypes = _.filter(defectTypes, dt => dt.legacyId > 1999 && dt.legacyId < 3000);
    } else {
      defectTypes = _.filter(defectTypes, dt => dt.legacyId < 2000 || dt.legacyId > 2999);
    }
    if (vm.machineLevel) {
      return defectTypes.filter(x=>x.entireMachine === true);
    }
    else {
      return defectTypes.filter(x=>x.entireMachine === false);
    }
  };

  vm.defectTypeChanged = (): void => {
    if (vm.defectTypeId) {
      let defect = vm.defectTypes.filter(x => x.id === vm.defectTypeId);
      vm.isCritical = defect.length > 0
        && (defect[0].severity === apsEnums.Severity.Critical || defect[0].severity === apsEnums.Severity.Major);
      const defectDefaultSize = defect[0].defaultInspectionSampleSize;
      vm.frequencyType = (defectDefaultSize === 10) ? Enums.FREQUENCY_TYPES.XOVER10
        : (defectDefaultSize === 4 ? Enums.FREQUENCY_TYPES.XOVER4
          : Enums.FREQUENCY_TYPES.COUNT);
      vm.frequencyTypeChanged();
    } else {
      vm.isCritical = false;
    }
  }

  var jobRun = _.find(vm.activity.jobRuns, (jr) => jr.startDate <= vm.timeFound && (!jr.endDate || vm.timeFound < jr.endDate));
  defectTypeService.getDefectTypesAndClassifications()
    .then((defectTypeData: DefectTypesAndClassifications) => {
      if (jobRun && jobRun.excludedDefectTypeIds && jobRun.excludedDefectTypeIds.length > 0) {
        defectTypeData.types = _.filter(defectTypeData.types, dt => _.every(jobRun.excludedDefectTypeIds, xt => xt !== dt.id));
      }
      _.forEach(defectTypeData.types, (type: DefectType) => {
        if (jobRun && type.wareClasses) {
          var override = _.find(type.wareClasses, (w) => w.wareClassId === jobRun.wareClassId);
          if (override && override.severity !== null) {
            type.severity = override.severity;
          }
        }
      });
      vm.defectTypes = defectTypeData.types;
      vm.classifications = defectTypeData.classifications;
    });

  defectService.getDefectEquipment()
    .then(function (data) {
      vm.equipmentList = data;
    });

  vm.drawDefect = function (x: any, y: any) {
    var img = new Image();
    img.className = 'defect-mark';
    img.id = defectMarkIdentifier;
    img.style.position = 'absolute';

    // find bottle to get coordinates
    var wrappedbottle = angular.element('#' + bottleIdentifier);

    if (wrappedbottle && wrappedbottle[0]) {
      img.style.left = (wrappedbottle[0].offsetLeft + x - 5) + 'px';
      img.style.top = (wrappedbottle[0].offsetTop + y + 12) + 'px';
    }
    // remove defect mark, if present
    var defect = document.getElementById(defectMarkIdentifier);
    if (defect != null) {
      defect.parentNode.removeChild(defect);
    }

    // add defect mark
    wrappedbottle.append(img);
  };

  vm.addOnClick = function (event: any) {
    vm.locationX = event.offsetX;
    vm.locationY = event.offsetY;
    vm.drawDefect(vm.locationX, vm.locationY);
  };


  vm.equipmentFailureClick = function () {
    if (vm.isEquipmentFailure === false) {
      vm.isEquipmentFailure = true;
    } else {
      vm.isEquipmentFailure = false;
    }
    vm.filteredDefectTypes();
  };

  vm.changeMachineLevel = function () {
    vm.filteredDefectTypes();
  }

  var id, commentId, userData: apsViewModels.UserData, moldLossId;
  $q.all([
    authService.getUserData().then(x => userData = x),
    newGuidService.getNewGuid('defect').then(x => id = x),
    newGuidService.getNewGuid('defectComment').then(x => commentId = x),
    newGuidService.getNewGuid('moldLoss').then(x => moldLossId = x)
  ]).then(() => vm.readyForSubmit = true);

  vm.addDefect = function () {
    if (!vm.readyForSubmit || vm.form.$invalid) {
      return;
    }

    var roleLocation = authDataService.getSelectedRoleLocation();

    var cmd: apsCommands.AddDefect = {
      id: id,
      shopId: vm.shopId,
      isMachineId: vm.machineLevel ? vm.machine.id : vm.section.machine.id,
      machineLevelDrop: vm.machineLevel && vm.machineLevelDrop ? vm.machineLevelDrop.gobNumber : undefined,
      section: !vm.machineLevel ? vm.section.sectionNumber : undefined,
      gob: !vm.machineLevel ? vm.gob.gobNumber : undefined,
      toolNumber: vm.mold ? vm.mold.toolNumber : undefined,
      currentRoleId: roleLocation.role.roleId,
      defectTypeId: vm.defectTypeId,
      isMoldRejectInUse: vm.isMoldRejectInUse,
      timeFound: vm.timeFound,
      locationX: vm.locationX,
      locationY: vm.locationY,
      comment: vm.defectComment,
      commentId: vm.defectComment ? commentId : undefined,
      frequencyType: vm.frequencyType && vm.frequencyTotal ? apsEnums.FrequencyType.Count : apsEnums.FrequencyType.None,
      frequencyCount: vm.frequencyCount,
      frequencyTotal: vm.frequencyTotal,
      frequencyPercent: vm.frequencyPercent,
      equipmentId: vm.equipment ? vm.equipment.id : undefined,
      isEquipmentFailure: vm.isEquipmentFailure,
      moldLossEquipment: vm.isMoldRejectInUse ? vm.moldLossEquipment : undefined
    };

    var defectType = _.find(vm.defectTypes, { id: vm.defectTypeId });
    var severity = defectType.severity;
    if (defectType.criticalThreshold !== null) {
      var percent = 0;
      if (cmd.frequencyType === apsEnums.FrequencyType.Count) {
        percent = cmd.frequencyCount / cmd.frequencyTotal;
      } else if (cmd.frequencyType === apsEnums.FrequencyType.Percentage) {
        percent = cmd.frequencyPercent / 100;
      }

      if (percent >= defectType.criticalThreshold) {
        severity = apsEnums.Severity.Critical;
      }
    }

    var moldLoss: apsCommands.AddMoldLoss = {
      id: moldLossId,
      defectId: id,
      plantId: $stateParams.plantId,
      critical: severity === apsEnums.Severity.Critical ? "Yes" : "No",
      isRejectInvalidMolds: vm.discardInvalidMolds,
      isRejectMold: vm.discardMold,
      shopId: vm.shopId,
      moldId: vm.mold && vm.mold.toolNumber ? vm.mold.toolNumber.toString() : undefined,
      reason: defectType.name,
      requestedByUserId: $stateParams.userId,
      section: vm.section ? vm.section.sectionNumber : undefined,
      gob: vm.gob ? vm.gob.gobNumber : undefined,
      gobName: vm.gob ? vm.gob.name : undefined
    };

    // fake event
    var event: apsEvents.DefectAdded = {
      id: cmd.id,
      plantId: undefined,
      shopId: cmd.shopId,
      isMachineId: cmd.isMachineId,
      machineLevelDrop: cmd.machineLevelDrop,
      dropName: vm.machineLevel && vm.machineLevelDrop ? vm.machineLevelDrop.name : undefined,
      section: cmd.section,
      gob: cmd.gob,
      gobName: !vm.machineLevel ? vm.gob.name : undefined,
      toolNumber: cmd.toolNumber,
      defectTypeId: cmd.defectTypeId,
      jobRunId: undefined,
      isMoldRejectInUse: cmd.isMoldRejectInUse,
      isEquipmentFailure: cmd.isEquipmentFailure,
      timeFound: cmd.timeFound,
      rejectStart: cmd.isMoldRejectInUse ? new Date() : undefined,
      maintenanceStart: cmd.isEquipmentFailure ? new Date() : undefined,
      severity: severity,
      frequencyType: cmd.frequencyType,
      frequencyCount: cmd.frequencyCount,
      frequencyTotal: cmd.frequencyTotal,
      frequencyPercent: cmd.frequencyPercent,
      equipmentId: cmd.equipmentId,
      locationX: cmd.locationX,
      locationY: cmd.locationY,
      createdByFullName: userData.fullName,
      name: defectType.name,
      abbreviation: defectType.abbreviation,
      defectTypeLegacyId: defectType.legacyId,
      comments: [],
      userId: userData.id,
      eventDate: new Date(),
      moldLossEquipment: cmd.moldLossEquipment
    };

    if (cmd.comment) {
      var comment = cmd.comment;
      event.comments = [{
        id: cmd.comment,
        plantId: undefined,
        shopId: cmd.shopId,
        isMachineId: cmd.isMachineId,
        section: cmd.section,
        gob: cmd.gob,
        defectId: cmd.id,
        timeFound: cmd.timeFound,
        comment: comment,
        createdByFullName: event.createdByFullName,
        gobName: event.gobName,
        abbreviation: event.abbreviation,
        defectTypeLegacyId: event.defectTypeLegacyId,
        severity: event.severity,
        userId: event.userId,
        eventDate: event.eventDate
      }];
    }

    loaderService.loadingPromise(defectService.addDefect(cmd)
      .then(() => {

        if (vm.isMoldRejectInUse) {
          if ((vm.moldLossEquipment == null || vm.moldLossEquipment == undefined) && vm.throwSelectEquipmentError) {

            this.notifyService.error('Please select an equipment for Auto Mold rejection');
            return;
          }
          defectService.addMoldLoss(moldLoss);
        }

        $modalInstance.close({ command: cmd, event: event });
      }, notifyService.handleApiErrors));
  };

  vm.cancel = function () {
    $modalInstance.close();
  };
}


// WEBPACK FOOTER //
// ./src/app/controllers/defects/addDefect.controller.ts